import React from "react";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import { breadcrumbs } from "../../common/utils/breadcrumbs";
import { Link } from "gatsby"

const StaticBanner = ({ GQLPage }) => { 
    const breadcrumbsList = breadcrumbs(GQLPage?.menu);
    
    //console.log("breadcrumbsList", GQLPage?.menu)

    return (
        <React.Fragment>           
            <section className="breadcrumb-section">
                    <Container>
                        <Row>
                            <Col>
                                <Breadcrumb>
                                    {/* <Breadcrumb.Item href="" className="d-none" >
                                        Home
                                    </Breadcrumb.Item> */}
                                    <li className="breadcrumb-item"><Link to={'/'}>Home</Link></li>  
                                    {breadcrumbsList?.map((breadcrumb, i, arr) => {
                                        if (arr.length - 1 === i) { // is the last item in the array
                                            return (
                                                <Breadcrumb.Item key={i} active>{breadcrumb.label}</Breadcrumb.Item>
                                            )
                                        } else {
                                            return (
                                                breadcrumb?.link_type === "none" ?
                                                    <li className="breadcrumb-item"><a href={"javascript:;"}>{breadcrumb.label}</a></li>
                                                :
                                                    <li className="breadcrumb-item"><Link to={`${breadcrumb.url}/`}>{breadcrumb.label}</Link></li>
                                            )
                                        }
                                    })} 
                                </Breadcrumb>
                            </Col>
                        </Row>
                    </Container>
                </section>
        </React.Fragment>
    );
};
export default StaticBanner;
